<!--城市组件-->
<template>
  <div>
    <van-field
      required
      class="cellRow iconRight"
      left-icon="info-o"
      @click-left-icon="portrait()"
      v-model="showPicker"
      :label="label"
      readonly
      clickable
      name="gradeNames"
      :value="type"
      right-icon="arrow"
      @click-right-icon="showTypePicker = true"
      @focus="showTypePicker = true"
      :rules="[{ required: true, message: `请选择${label}` }]"
    />
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="dataList"
        @confirm="onConfirm"
        @cancel="showTypePicker = false"
        value-key="name"
        ref="picker"
        :children="values"
      />
    </van-popup>
  </div>
</template>

<script>
import { classification } from '@/utils/classification.js';
// import { delete } from 'vue/types/umd';
export default {
  name: '',
  props: {
    value: null,
    clearable: false,
    gradeNames: null,
    portraitText: null,
    label: null,
  },
  data: () => ({
    props: {
      value: 'id',
      label: 'name',
      children: 'children',
    },
    values: ['id'],
    changed: false, // 用户是否手动修改过
    dataList: [
      // {
      //   name: '全部',
      //   level: 0,
      //   id: -1,
      //   children: [
      //     {
      //       name: '全部',
      //       level: 0,
      //       id: -1,
      //       children: [{ name: '全部', level: 0, id: -1 }],
      //     },
      //   ],
      // },
    ],
    // gradeId:[],
    result: [],
    showValue: '',
    showTypePicker: false,
    showPicker: null,
    type: '',
  }),
  watch: {
    value: function(value) {
      console.log('value', value);
      value && !this.changed && this.setClassification(this.value);
      this.changed = false;
    },
    gradeNames: function(value) {
      console.log('value', value);
      this.showPicker = value == '1' ? this.getCheckName(this.value) : value;
    },
  },
  methods: {
    portrait() {
      this.$emit('portraits', this.portraitText);
    },
    onConfirm(value) {
      console.log(value);
      this.showPicker = value.join('/');
      const data = this.$refs.picker.getValues();
      let arr = [];
      data.map((v, index) => {
        if (v.id == -1 && index <= 0) {
          arr.push(v.id);
        } else if (v.id != -1) {
          arr.push(v.id);
        } else {
          arr.push(null);
        }
      });
      console.log(arr);
      this.$emit('input', arr);
      this.$emit('getNames', this.showPicker);

      this.showTypePicker = false;
    },

    getArrlevelList(level, parentId) {
      const selectItem = classification.filter(
        value => value['level'] == level && value['parentId'] == parentId,
      );
      // let  selectItem=null

      //  getGradlist({level:level,parentId:parentId}).then(res=>{
      //   console.log(res.data.list)
      //  selectItem= res.data.list
      // })
      // return selectItem
      //  console.log(selectItem)
      return selectItem;
    },
    getCheckName(val) {
      if (!val || !val.length) {
        return false;
      }
      let arr = [];
      val.forEach(item => {
        if (item) {
          console.log(classification.filter(value => value['id'] == item));
          arr.push(classification.filter(value => value['id'] == item)[0].name);
        }
      });
      return arr.join('/');
    },
    handleItemChange(val) {
      console.log(val);
      this.changed = true;
      let id = val.slice().pop();
      // // 设置城市子集
      this.setChildren(id, this.dataList);
      this.$emit('input', val);
    },
    // 子集
    setChildren(id, datas) {
      if (!datas || !datas.length) {
        return false;
      }
      datas.forEach(item => {
        if (item.id === id) {
          if (!item.children || !item.children.length) {
            return this.getCity(item.level + 1, item.id).then(dataList => {
              item.children = dataList.length ? dataList : null;
            });
          }
          return false;
        } else {
          this.setChildren(id, item.children);
        }
      });
      this.dataList = datas;
    },
    // 获取城市
    getCity(level = 0, parentId = 0) {
      let that = this;
      return new Promise(function(resolve) {
        let dataList = that.getArrlevelList(level, parentId) || [];
        let result = [];
        if (dataList.length) {
          result = dataList.map(item => {
            if (item.level > 0) {
              item.children =
                that.getArrlevelList(item.level + 1, item.id).length > 0
                  ? that.getArrlevelList(item.level + 1, item.id)
                  : null;
              console.log(item.children);
            } else if (level < 2) {
              item.children = [];
            }
            return item;
          });
        }
        resolve(result);
      });
    },
    setClassification(id) {
      this.result.length = 0;
      this.result = id;
      let that = this;
      this.getCity(0, id[0]).then(data => {
        this.dataList = this.dataList.concat(data);
        this.dataList.forEach((item, index) => {
          if (item.id > 0) {
            item.children = that.getArrlevelList(item.level + 1, item.id);
            // if (item.id == this.result[index]) {
            //   item.defaultIndex = 2;
            //   console.log(item);
            // }
            item.children.map((item, index) => {
              item.children =
                that.getArrlevelList(item.level + 1, item.id).length > 0
                  ? that.getArrlevelList(item.level + 1, item.id)
                  : [];
              // if (item.id == this.result[index]) {
              //   item.defaultIndex = 2;
              //   console.log(item);
              // }
              if (item.children.length <= 0) {
                item.children = [{ name: '', id: '-1' }];
              }
            });
          }
        });
      });
    },
  },
  created() {
    let hasValue = !!this.value.length > 0;
    // this.getCity(0, 0).then(data => {
    //   this.dataList = this.dataList.concat(data);
    // });
    this.setClassification([0]);
    console.log(this.dataList);
    if (hasValue) {
      console.log(this.value);
      this.setClassification(this.value);
    }
  },
};
</script>
<style>
.elcascader {
  height: 32px;
  font-size: 12px;
}
</style>
